import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Card, CardContent, Stack, Typography } from '@mui/material'
import { type RequestedResources } from '../../models/auth/requested-resources'
import lockClose from '../../assets/images/lock-close-cx-round.svg'
import CenteredCardLayout from '../../layouts/centered-card-layout'

interface NotAuthorizedPageProps {
  requestedResources: RequestedResources
}

const NotAuthorizedPage: React.FC<NotAuthorizedPageProps> = ({ requestedResources }) => {
  const { user } = useAuth0()

  const requestedPermissions: string[] = []
  Object.entries(requestedResources)
    .forEach(([accessRight, resources]) => {
      for (const resource of resources) {
        requestedPermissions.push(`${accessRight}:${resource as string}`)
      }
    })
  const requestedResourcesStr = requestedPermissions.join(', ')
  const permissionRequest =
    `User:\n${user?.name as string}\n\nPermission Code:\n${requestedResourcesStr}`

  return (
    <CenteredCardLayout addPadding>
      <Card
        variant='outlined'
        sx={{
          width: 'fit-content',
          padding: 2,
          borderRadius: 0,
        }}
      >
        <CardContent
          sx={{
            height: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box>
            <img src={lockClose} alt='Access Denied' style={{ height: '128px' }}/>
          </Box>
          <Stack gap={4}>
            <Typography align='center' pt={4} pb={4}>
              You don&apos;t have the correct permissions to access this page.
            </Typography>
            <Typography>
              To request permission, send these information to the administrator:
            </Typography>
            <Typography sx={{ fontFamily: 'monospace', wordBreak: 'break-all', whiteSpace: 'pre-wrap', maxWidth: '500px' }}>
              {permissionRequest}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </CenteredCardLayout>
  )
}

export default NotAuthorizedPage
